module.exports = __webpack_public_path__ + "img/icon_was_due.30c55ca2.png";